import React from 'react';
import { Outlet } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';
import Sidebar from '../components/Sidebar';

function DashboardLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 5,
          maxHeight: '100vh',
          maxWidth: '100vw',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default DashboardLayout;
